import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#db9f95'
            },
            dark: {
                primary: '#db9f95'
            },
        },
    },
})
